import { KoukyuuApi } from "@/api/KoukyuuApi";
import { Koukyuu, KoukyuuDetail } from "@/types/Shinsei";

export class KoukyuuService {

  /**
   * 公休申請を登録します
   */
  public async create(req: Koukyuu) {
    const api = new KoukyuuApi();
    try {
      return await api.createShinsei(req);
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 公休申請を登録します
   */
  public async delete(koukyuuId: number) {
    const api = new KoukyuuApi();
    try {
      return await api.deleteShinsei(koukyuuId);
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 早番遅番申請を登録します
   */
  public async getDetail(id: number): Promise<KoukyuuDetail> {
    const api = new KoukyuuApi();
    try {
      return await api.getDetail(id);
    } catch (e: any) {
      throw e
    }
  }
}
